import { View } from "binder"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IntegerEditorViewModel } from "./integerEditor-viewModel"

export class IntegerEditorView extends View<IntegerEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-84D51DFD-1D11-40F4-B197-22DFC7BC60B6"
    }
    loadHtml(): string {
        let element = require('./integerEditor.html').default;
        let style = require('./integerEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set value(v: number) { this._value =getAsNumber(v,true); } public get value(): number { return this._value;} private _value: number;

}
